import API from './api';

export default {
    // Get all organization roles for the current account
    getAccountOrganizationRoles: () => API({
        url: 'account/organization_roles',
        method: 'GET',
    }),

    // Get all accounts with roles in an organization
    getOrganizationAccountRoles: (organizationId) => API({
        url: `organizations/${organizationId}/accounts/roles`,
        method: 'GET',
    }),

    // Assign a role to an account in an organization
    assignOrganizationRole: (organizationId, accountId, role, title, bio, photo, name, last_name, instagram, tiktok, facebook, twitter) => API({
        url: `organizations/${organizationId}/accounts/${accountId}/role`,
        method: 'POST',
        json: { role, title, bio, photo, name, last_name, instagram, tiktok, facebook, twitter },
    }),

    // Remove a role from an account in an organization
    removeOrganizationRole: (organizationId, accountId) => API({
        url: `organizations/${organizationId}/accounts/${accountId}/role`,
        method: 'DELETE',
    }),

    // Upload staff photo - returns presigned S3 URL
    uploadStaffPhoto: (organizationId, accountId) => API({
        url: `organizations/${organizationId}/accounts/${accountId}/role/photo`,
        method: 'POST',
    }),

};